//Import all frontend scripts here

// header
import { headerInit } from './components/header';

// Video
import { videoBlockModifyInit } from './components/video-block-modify';

headerInit();
videoBlockModifyInit();
